// src/features/authz/logic.ts
// Small helpers for the authorization inspector.
// See docs/ux/authz-ia.md.

export function parseTupleString(input: string): { user: string; relation: string; object: string } | null {
  // "user:bob viewer document:readme" — three space-separated tokens.
  const parts = input.trim().split(/\s+/);
  if (parts.length !== 3) return null;
  const [user, relation, object] = parts;
  return { user, relation, object };
}
